import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Icon from '../Icon/Icon';

import type { IconSize } from '../../icons/types';

export type BackButtonColor = 'default' | 'dark' | 'inverse';

const COLOR_MAP: Record<BackButtonColor, 'default' | 'black' | 'white'> = {
  default: 'default',
  dark: 'black',
  inverse: 'white',
};

type BackButtonProps = {
  ariaLabel?: string;
  className?: string;
  color?: BackButtonColor;
  onClick?: () => void;
  size?: IconSize;
};

function BackButton({
  ariaLabel,
  className,
  color = 'default',
  onClick,
  size = 'lg',
}: Readonly<BackButtonProps>): JSX.Element {
  const { t } = useTranslation();
  const accessibleLabel = ariaLabel ?? t('common:Go back', { defaultValue: 'Go back' });

  return (
    <button
      aria-label={accessibleLabel}
      className={clsx('back-button', `back-button--color-${color}`, className)}
      onClick={onClick}
      type="button"
    >
      <Icon color={COLOR_MAP[color]} name="arrow-left" size={size} />
    </button>
  );
}

export default BackButton;
